import type { Renderer } from '../Renderer';
import { PixiRenderer } from './PixiRenderer';

/**
 * Factory for the Pixi.js renderer. Callers receive the abstract `Renderer`
 * type — Pixi import surface stays inside this directory (ADR-0007).
 */
export function createPixiRenderer(): Renderer {
  return new PixiRenderer();
}
